/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxDeclarationResponse } from '../../models/tax-declaration-response';

export interface ApiTaxDeclarationYearGet$Plain$Params {
  year: number;
}

export function apiTaxDeclarationYearGet$Plain(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationYearGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationYearGet$Plain.PATH, 'get');
  if (params) {
    rb.path('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxDeclarationResponse>;
    })
  );
}

apiTaxDeclarationYearGet$Plain.PATH = '/api/TaxDeclaration/{year}';
